// Branding do tenant para o app CRM — versão SEM Vuetify do plugins/branding.ts
// (aquele importa ./vuetify e arrastaria a lib inteira para este bundle).
//
// O contrato é o mesmo do Hub: buscar o branding do hostname ANTES do mount,
// com teto de 4s e fallback NEUTRO — nunca a identidade de outro tenant.
import { useTenantStore } from '@/stores/tenantStore';

const TIMEOUT_MS = 4000;

export async function bootstrapCrmBranding(): Promise<void> {
  const tenantStore = useTenantStore();
  try {
    await Promise.race([
      tenantStore.fetchBranding(),
      new Promise((resolve) => setTimeout(resolve, TIMEOUT_MS)),
    ]);
  } catch {
    // fail-neutral: o store já cai no NEUTRAL
  }
  const titulo = tenantStore.branding?.titulo || tenantStore.nome || 'Hub';
  document.title = `${titulo} | CS`;
  // Acento primário do tenant no escopo do DS (o Hub faz isso via Vuetify
  // theme; aqui escrevemos o token direto).
  const primary = (tenantStore.branding as any)?.cores?.primary;
  if (primary) {
    document.documentElement.style.setProperty('--crm-brand-primary', primary);
  }
}
